module.exports = new __parcel__URL__("telia-logo.a5f5e7d7.png").toString();